import List from "@/components/list";

const Table = args => {

  const tableConfig = [
    {
      label: "考试名称",
      prop: "name",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "考试平均分",
      prop: "average",
      minWidth: "150",
      showOverflowTooltip: true
    }
  ];
  return (
    <List
      {...args}
      talbeCols={tableConfig}
    />
  );
};

export default Table;
